import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { VirtualMirrorModal } from "../../../../../../VirtualMirrorModal/modules/VTO/VirtualMirror/components/VirtualMirrorModal/VirtualMirrorModal.js";
import { useVto } from "../../../../../../../../context/modules/VTO/context/VtoProvider.js";
import { vtoEvent } from "../../../../../../../../utils/modules/VTO/utils/vto-event.js";
import { mapGraphVariantsToVirtualMirror } from "../../../../../../../mappers/modules/VTO/VirtualMirror/mappers/mapGraphVariantsToVirtualMirror.js";
import { TryOnButton } from "../../../../../../../../components/TryOnButton/modules/VTO/components/TryOnButton/TryOnButton.js";
import { useProductWithAFrameData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { useCmsData } from "../../../../../../../../../../context/context/CmsContext.js";
import { getActiveBrandPromotion } from "../../../../../../../../../../utils/utils/get-active-brand-promotion.js";
const VirtualMirrorContainer = ({
  className,
  onToggleWishlist,
  wishlistedSkuItems
}) => {
  const { isVtoTransitionsEnabled } = useFeatureToggles();
  const {
    activeVariant: { sku, isVtoEnabled },
    product
  } = useProductWithAFrameData();
  const { isVtoActive, isVtoFeatureEnabled } = useVto();
  const { brandPromotions } = useCmsData();
  const { brandName, variants } = product;
  const isVirtualMirrorEnabled = isVtoEnabled && isVtoFeatureEnabled;
  React.useEffect(() => {
    if (sku && isVirtualMirrorEnabled) {
      vtoEvent("vto.view", { sku });
    }
  }, [sku, isVirtualMirrorEnabled]);
  const brandLogo = getActiveBrandPromotion(brandName, brandPromotions)?.logo;
  const mappedVTOVariants = isVirtualMirrorEnabled ? mapGraphVariantsToVirtualMirror(product, variants, sku, brandLogo, isVtoTransitionsEnabled) : void 0;
  const isTransitionFeatureEnabled = isVtoTransitionsEnabled && product.isOfferedWithPrescriptions;
  const transitionFeature = isTransitionFeatureEnabled ? { enabled: true } : void 0;
  if (!isVirtualMirrorEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TryOnButton, { className }), isVtoActive && /* @__PURE__ */ React.createElement(
    VirtualMirrorModal,
    {
      variants: mappedVTOVariants,
      onToggleWishlist,
      wishlistedSkuItems,
      transitionFeature
    }
  ));
};
export {
  VirtualMirrorContainer
};
//# sourceMappingURL=VirtualMirrorContainer.js.map
